import React from 'react'
import { ShiftIntelligenceWidgetProvider } from './context/ShiftIntelligenceWidgetProvider'
import { SmartWidget } from '@workwhile/ui'

export const ShiftIntelligenceWidget = () => {
  return (
    <ShiftIntelligenceWidgetProvider>
      <SmartWidget triggerSize="medium" />
    </ShiftIntelligenceWidgetProvider>
  )
}
